import modals from 'webmodals/modals';
import templateUrl from 'webmodals/modal.htm';
import resolve from 'ioc/resolve';

function ShowModalDirective() {
    return {
        scope: false,
        restrict: 'A',
        link($scope, $element, $attr) {
            //$element.css('cursor', 'pointer');
            $element.on('click', ev => {
                modals.open({
                    templateUrl: $attr.showModal || $attr.templateUrl,
                    size: $attr.size
                });
            });
        }
    };
}

export default ShowModalDirective;